import React from 'react';
import classnames from 'classnames';
import styles from './SearchCount.module.scss';
import { FormattedMessage } from 'react-intl';

export interface SearchCountProps {
  count: number;
  countKey: string;
  className?: string;
}

export const SearchCount = ({ count = 0, countKey, className }: SearchCountProps) => {
  return count < 0 ? null : (
    <div className={classnames(styles.searchCount, className)}>
      <FormattedMessage id={countKey} values={{ count }} />
    </div>
  );
};
